import type { AppCodes } from './navigationTypes';

export const APP_CODE = {
    ONTARIO: 'RPW',
    ALBERTA: 'RPWAB',
    NOVA_SCOTIA: 'RPWNS',
    SASKATCHEWAN: 'RPWSK',
    MANITOBA: 'RPWMB',
    BRITISH_COLUMBIA: 'RPWBC',
    DOC_SERVICE: 'DS',
    DOCUMENT_RETRIEVAL: 'DR',
    WILLS: 'WILL',
} as const satisfies Record<string, AppCodes>;
